
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { PhotoUploadDialog } from "./dialogs/PhotoUploadDialog";

interface UploadCollectionPhotoDialogProps {
  userId?: string;
  collectionKey: string;
  onPhotoUploaded: () => void;
}

export function UploadCollectionPhotoDialog({ 
  userId, 
  collectionKey, 
  onPhotoUploaded 
}: UploadCollectionPhotoDialogProps) {
  const { language } = useLanguage();

  return (
    <PhotoUploadDialog
      userId={userId}
      onPhotoUploaded={onPhotoUploaded}
      initialCategory={collectionKey}
      trigger={
        <Button size="sm" variant="outline">
          {t('gallery.addPhoto', language)}
        </Button>
      }
    />
  );
}
